import React from 'react';

interface propsTypes {
  children?: React.ReactNode;
  className?: string;
}

const H5 = (props:propsTypes) => {
  const { children } = props;
  return <h5 {...props}>{children}</h5>;
};

export default H5;
